import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareReportsDeploymentFrequencyClassicRoute: InvariantJiraRoute = {
	name: 'software-reports-deployment-frequency-classic',
	path: '/jira/software/c/projects/:projectKey/reports/deployment-frequency',
	exact: true,
};
